import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // Services data
  services: {
    data: [],
    pagination: {
      next: null,
      previous: null,
      count: 0,
    },
  },
  // Tasks data
  tasks: {
    data: [],
    pagination: {
      next: null,
      previous: null,
      count: 0,
    },
  },
  // Subtasks data
  subtasks: {
    data: [],
    pagination: {
      next: null,
      previous: null,
      count: 0,
    },
  },
  // Current active tab (0: services, 1: tasks, 2: subtasks)
  activeTab: 0,
  // Filters
  filters: {
    name: "",
  },
  // UI state
  loading: false,
  error: null,
};

const archiveSlice = createSlice({
  name: "archive",
  initialState,
  reducers: {
    // Name filter
    setNameFilter: (state, action) => {
      state.filters.name = action.payload;
    },

    // Services reducers
    setServices: (state, action) => {
      state.services = action.payload;
    },
    clearServices: (state) => {
      state.services = initialState.services;
    },
    removeServiceFromArchive: (state, action) => {
      const serviceId = action.payload;
      state.services.data = state.services.data.filter(
        (service) => service.id !== serviceId
      );
      state.services.pagination.count = Math.max(
        0,
        state.services.pagination.count - 1
      );
    },

    // Tasks reducers
    setTasks: (state, action) => {
      state.tasks = action.payload;
    },
    clearTasks: (state) => {
      state.tasks = initialState.tasks;
    },
    removeTaskFromArchive: (state, action) => {
      const taskId = action.payload;
      state.tasks.data = state.tasks.data.filter((task) => task.id !== taskId);
      state.tasks.pagination.count = Math.max(0, state.tasks.pagination.count - 1);
    },

    // Subtasks reducers
    setSubtasks: (state, action) => {
      state.subtasks = action.payload;
    },
    clearSubtasks: (state) => {
      state.subtasks = initialState.subtasks;
    },
    removeSubtaskFromArchive: (state, action) => {
      const subtaskId = action.payload;
      state.subtasks.data = state.subtasks.data.filter(
        (subtask) => subtask.id !== subtaskId
      );
      state.subtasks.pagination.count = Math.max(
        0,
        state.subtasks.pagination.count - 1
      );
    },

    // Tab management
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },

    // Filters
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearFilters: (state) => {
      state.filters = initialState.filters;
    },

    // UI state
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },

    // Reset all data
    resetArchive: (state) => {
      return initialState;
    },
  },
});

export const {
  setNameFilter,
  setServices,
  clearServices,
  removeServiceFromArchive,
  setTasks,
  clearTasks,
  removeTaskFromArchive,
  setSubtasks,
  clearSubtasks,
  removeSubtaskFromArchive,
  setActiveTab,
  setFilters,
  clearFilters,
  setLoading,
  setError,
  clearError,
  resetArchive,
} = archiveSlice.actions;

export default archiveSlice.reducer;
